import { SVGProps } from 'react';

function CompanyIndustryIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={props.width}
      height={props.height}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        d='M10.667 2.583H8.333V1.417L7.167.25H4.833L3.667 1.417v1.166H1.333A1.17 1.17 0 0 0 .167 3.75v2.917c0 .437.233.805.583 1.009v1.907c0 .648.52 1.167 1.167 1.167h8.166c.648 0 1.167-.52 1.167-1.167V7.67c.344-.204.583-.577.583-1.003V3.75a1.17 1.17 0 0 0-1.166-1.167ZM4.833 1.417h2.334v1.166H4.833V1.417Zm-3.5 2.333h9.334v2.917H7.75v-1.75h-3.5v1.75H1.333V3.75Zm5.25 3.5H5.417V6.083h1.166V7.25Zm3.5 2.333H1.917v-1.75H4.25v.584h3.5v-.584h2.333v1.75Z'
        fill={props.fill}
      />
    </svg>
  );
}

export default CompanyIndustryIcon;
